"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFitSizeToElement = void 0;
/**
 * @param {ThreeBase} visualization
 * @param {Element} element
 */
var updateFitSizeToElement = exports.updateFitSizeToElement = function updateFitSizeToElement(visualization, element) {
  if (visualization && visualization.setFitSize) {
    if (!element) {
      visualization.setFitSize(null);
    } else {
      var _element$getBoundingC = element.getBoundingClientRect(),
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height;
      if (width > 0 && height > 0) {
        visualization.setFitSize({
          width: width,
          height: height
        });
      }
    }
  }
  return {
    updateCameraPosition: function updateCameraPosition() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var updateFn = visualization.setCameraPositionToCurrentDesignArea;
      updateFn && updateFn.call(visualization, options);
    }
  };
};